import { render, staticRenderFns } from "./schoolServiceView.vue?vue&type=template&id=a6296dcc&scoped=true&"
import script from "./schoolServiceView.vue?vue&type=script&lang=js&"
export * from "./schoolServiceView.vue?vue&type=script&lang=js&"
import style0 from "./schoolServiceView.vue?vue&type=style&index=0&id=a6296dcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6296dcc",
  null
  
)

export default component.exports